import { DateInterval } from '~/DateTime';
import { ProductPrice } from '~/Product';

export default class ProductPriceHistoryRecord {
	productPrice: ProductPrice;

	dateInterval: DateInterval;

	constructor(productPrice: ProductPrice, dateInterval: DateInterval) {
		this.productPrice = productPrice;
		this.dateInterval = dateInterval;
	}
}
